<template>
  <div>
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        v-model.number="form.mType"
        size="small"
        clearable
        placeholder="请选择商人类型"
        @change="getBusinessmanList('status')"
      >
        <el-option
          v-for="item in busunessList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-input
        placeholder="商人ID"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.uid"
        class="param-input"
        @keyup.enter.native="getBusinessmanList('status')"
      ></el-input>
      <el-input
        placeholder="账户名"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.name"
        class="param-input"
        @keyup.enter.native="getBusinessmanList('status')"
      ></el-input>
      <el-input
        placeholder="昵称"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.nickname"
        class="param-input"
        @keyup.enter.native="getBusinessmanList('status')"
      ></el-input>
      <el-input
        placeholder="手机号"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.mobile"
        class="param-input"
        @keyup.enter.native="getBusinessmanList('status')"
      ></el-input>
      <el-input
        placeholder="商人所属聚商ID"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.cid"
        class="param-input"
        @keyup.enter.native="getBusinessmanList('status')"
      ></el-input>
      <el-input
        placeholder="商人所属渠道"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.channel"
        class="param-input"
        @keyup.enter.native="getBusinessmanList('status')"
      ></el-input>
      <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="editBill('add')">新增聚商</el-button>
      <el-button type="primary" size="mini" @click="getBusinessmanList('status')">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        prop="uid"
        label="商人ID"
        fixed
        align="center"
        :show-overflow-tooltip="true"
        min-width="110"
      >
        <template slot-scope="scope">
          <span>{{scope.row.uid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="账号" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mType" label="商人类型" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.mType | businessType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cid" label="商人所属聚商ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.cid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="channel" label="商人渠道" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.channel }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="商人账户余额(元)" align="center" min-width="130">
        <template slot-scope="scope">
          <span>{{scope.row.balance | transformFloat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="hasLocked" label="已禁止登陆" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.hasLocked ?'是':"否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lockReason" label="禁止登陆的原因" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.lockReason || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isDeleted" label="是否已经删除" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.isDeleted ?'是':"否" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="300">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="editBill('edit',scope.row)"
          ></el-button>
          <el-button
            type="warning"
            size="mini"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          ></el-button>
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="addOrDebitScore(scope.row)"
          >上分</el-button>
          <el-button type="success" size="mini" icon="el-icon-edit" @click="seekScore(scope.row)">追分</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="form.pageNumber"
      :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 子组件 -->
    <edit-bill ref="editBill" @handlerBillList="handlerBillList"></edit-bill>
    <addOrDebitScore ref="addOrDebitScore" @handlerBillList="handlerBillList"></addOrDebitScore>
    <seekScore ref="seekScore" @handlerBillList="handlerBillList"></seekScore>
  </div>
</template>
<script>
import API from "@/api";
import EditBill from "./components/editBill";
import AddOrDebitScore from "./components/addOrDebitScore";
import SeekScore from "./components/seekScore";
export default {
  components: {
    EditBill,
    AddOrDebitScore,
    SeekScore,
  },
  data() {
    return {
      // 列表数据
      tableData: [],
      total: "",
      time: "",
      // 请求列表数据参数
      form: {
        pageNumber: 1,
        pageSize: 10,
        uid: undefined,
        name: undefined,
        nickname: undefined,
        mobile: undefined,
        cid: undefined,
        channel: undefined,
      },
      busunessList: [
        { label: "聚商", value: 1 },
        { label: "普通商人", value: 2 },
      ],
    };
  },
  created() {
    this.getBusinessmanList();
  },
  methods: {
    handleClear(type) {
      this.form[type] = undefined;
      this.getBusinessmanList("status");
    },
    getBusinessmanList(type) {
      if (type === "status") {
        this.pageNumber = 1;
      }
      API.getBusinessmanList(this.form)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          // this.loading = false
        })
        .catch(() => {
          // this.loading = false
        });
    },

    handlerBankList() {
      this.getBusinessmanList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.form.pageSize = size;
      this.form.pageNumber = 1;
      this.getBusinessmanList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.form.pageNumber = pageNumber;
      this.getBusinessmanList();
    },
    editBill(type, data) {
      //vm.$refs：一个持有注册过ref特性的所有DOM元素和组件实例的对象
      // 调用子组件的open事件；传参数type、data到子组件到open方法
      this.$refs.editBill.open(type, data);
    },
    addOrDebitScore(data) {
      this.$refs.addOrDebitScore.open(data);
    },
    seekScore(data) {
      this.$refs.seekScore.open(data);
    },
    handlerBillList() {
      this.getBusinessmanList();
    },
    handleDelete(row) {
      this.$confirm("确定删除？")
        .then(() => {
          API.delBusinessman({ uids: [row.uid] }).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.getBusinessmanList();
            } else {
              this.$message.error(res.tip);
            }
          });
        })
        .catch(() => {
          this.$message("取消删除");
        });
    },
  },
};
</script>

